class LenisExclude {
  constructor(el,opt){
    this.el = el;
    if(document.querySelector(el)){
      this.event(el);
    }
  }
  event(el){
    const excludeEle = document.querySelector(el);
    excludeEle.addEventListener('wheel',(e)=>{
      e.stopPropagation();
    })
  }
}
